import CustomInput from "@/components/CustomInput/CustomInput.vue";
import Switcher from "@/components/Switcher/Switcher.vue";
import LoaderMini from "@/components/LoaderMini/LoaderMini.vue"
import Preloader from "@/components/Preloader/Preloader.vue";
import InfoMessage from "../../components/AlertMessage/InfoMessage.vue";
import ChangeEmailModal from "@/components/__new_ui_kit/Modals/ChangeEmailModal/ChangeEmailModal";
import {defaultComponentProps, defaultModalEvents, defaultModalProps} from "@/components/__new_ui_kit/Modal/defaults";
import BButton from "@/components/__new_ui_kit/Button/BButton";

import api_requests from "../../store/api/api_requests";
import PhoneMaskInput from "vue-phone-mask-input";

import {mapGetters, mapActions} from "vuex";

export default {
    name: 'Account',
    components: {
        CustomInput,
        Switcher,
        PhoneMaskInput,
        LoaderMini,
        Preloader,
        InfoMessage,
        BButton
    },
    data() {
        return {
            name: '',
            first_name: {},
            last_name: {},
            phone: false,
            disableTrue: true,
            mail: '',
            image_name: '',
            image_size: '',
            errorReqEmail: false,
            validCurrentPasswordForEmail: false,
            errored: false,
            id_dashboard: 0,
            disabled: true,
            active_id_subscription: 0,
            old_id_subscription: 0,
            subscription_status: 'Neutral',
            plan_name: '',
            plan_price: '',
            plan_id: '',
            periodicity: '',
            expiration_date: '',
            paymentHistoryList: [],
            oldPlans: [],
            allPlans: [],
            test:[],
            showPreloader: false,
            successPreloader: false,
            failPreloader: false,
            showPreloaderMail: false,
            showPreloaderMailSuccess: false,
            showPreloaderMailFail: false,
            checkMail: '',
            checkCurrentPassword: '',
            showMainPreloader: true,
            highLight: false,
            billing_plan_list: [],
            terminateStatus: '',
            disTerminateButton: false,
            password: '',
            requestSend: false,
            validNumber: false,
            showPhoneError: false,
            errors: null,
            firstName: '',
            lastName: '',
            billingTablePreloading: false
        }
    },
    computed: {
        ...mapGetters(['userInfo']),
        isError() {
            return this.errorReqEmail || this.first_name.invalide || this.last_name.invalide
        }
    },
    watch: {
        phone() {
            this.showPhoneError = false
        },
        firstName () {
            if (this.errors && this.errors['first_name'] && this.errors['first_name'].length > 0) {
                this.errors['first_name'] = []
            }
            this.showPreloader = false
        },
        lastName () {
            if (this.errors && this.errors['last_name'] && this.errors['last_name'].length > 0) {
                this.errors['last_name'] = []
            }
            this.showPreloader = false
        }
    },
    methods: {
        ...mapActions(['details']),
        onValidate (event) {
            this.validNumber = event.isValidByLibPhoneNumberJs
        },
        disableSendFormPersonal() {
            document.getElementById('save_personal_data').click();
            return false;
        },
        terminate_active_subscription() {
            this.terminateStatus = 'loading'
            this.disTerminateButton = true
            this.billingTablePreloading = true
            this.$store.dispatch('terminate_subscription')
                .then((res) => {
                    this.terminateStatus = 'success'
                    setTimeout(()=> {
                        this.details()
                            .then(() => {
                                this.billing_plan_list = this.userInfo.all_subscriptions || []
                                this.billingTablePreloading = false
                            })
                            .catch((error) => {
                                this.billingTablePreloading = false
                                console.log(error)
                            })
                    }, 5000)
                })
                .catch((err) => {
                    this.terminateStatus = 'error'
                })
        },
        inputLN(data) {
            this.last_name = data
            this.lastName = data.inp
        },
        inputFN(data) {
            this.first_name = data
            this.firstName = data.inp
        },
        validateEmail(val) {
            // var re = /^([a-z0-9_+-]+\.)*[a-z0-9_+-]+@[a-z0-9_+-]+(\.[a-z0-9_+-]+)*\.[a-z]{2,6}$/;
            const regexQuery = "^\\w+([\\+.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$"
            const email = new RegExp(regexQuery, "i")
            // return re.test(email);
            return email.test(val)
        },

        inputCurrentPassword(data) {
            this.validCurrentPasswordForEmail = (data.target.value.trim().length > 0);
        },
        openChangeEmailModal() {
            this.$modal.show(ChangeEmailModal,
              {
                  ...defaultComponentProps, 'defaultEmail': this.mail
              },
              {
                  ...defaultModalProps('change-email-modal'), name: 'change-email-modal'
              },
              {
                    ...defaultModalEvents()
              })
        },
        // убрал router.push в applyCb у модалки
        // updateDetails() {
        //     this.$store.dispatch('getDetails').then((res) => {
        //         let oldMail = JSON.parse(JSON.stringify(this.mail))
        //         this.mail = res.data.email
        //         console.log(res, oldMail, res.data.email)
        //         if (oldMail !== res.data.email) {
        //             this.$router.push('please-activate')
        //         }
        //     })
        // },
        changeEmailExt() {
            this.mail = this.oldMail
            this.highLight = !this.highLight
            this.disabled = !this.disabled
            this.errorReqEmail = false
            this.checkMail = false
        },
        saveUserData() {
            this.failPreloader = false
            this.successPreloader = false
            this.showPhoneError = false
            const data = {
                first_name: this.first_name.inp,
                last_name: this.last_name.inp,
                phone: this.phone,
                mail: this.mail,
            }
            // if (!!this.phone && this.phone.length > 0 && !this.validNumber) {
            //     this.showPhoneError = true
            // }
            if (!this.errorReqEmail && !this.first_name.invalide && !this.last_name.invalide) {
                this.errored = false
                this.errors = null
                this.showPreloader = true
                this.$store.dispatch('changeUserData', data)
                    .then(res => {
                         this.$store.dispatch('details', res.data).then(error => console.log(error))
                         setTimeout(() => this.successPreloader = Boolean(res.status === 200), 500)
                    })
                    .catch((err) => {
                        this.errors = err.response.data.errors
                        this.successPreloader = false
                        this.failPreloader = true
                    })
                    .finally(() => {

                    })
            } else {
                this.errored = true
            }
        },
        getSubscriptionId() {
            // axios
            //     .post(
            //         process.env.VUE_APP_API+'/dashboard-integration/subscriptions', {"client_id": String(JSON.parse(localStorage.user).id)},
            //         {
            //             headers: {
            //                 'Authorization': localStorage.token
            //             }
            //         }
            //     )
            //     .then(resp => {
            //         let infoSub = resp.data.data.subscriptions.data.filter(val => val.status === 'ACTIVE')
            //         console.log('____')
            //         console.log(infoSub)
            //         this.test = infoSub
            //         this.oldPlans = resp.data.data.subscriptions.data.filter(val => val.status === 'CHANGED_PLAN')
            //         this.active_id_subscription = infoSub.length > 0 ? infoSub[0].id : -1
            //         this.plan_id = infoSub.length > 0 ? infoSub[0].workspace_plan_id : -1
            //         this.expiration_date = infoSub.length > 0 ? infoSub[0].end_at.split(' ')[0] : -1
            //         this.getPaymentsStatus(this.active_id_subscription)
            //         this.getActivePlanName()
            //         this.getPaymentHistory()
            //     })
            //     .catch(err => {
            //         console.log(err)
            //     })
        },
        getPaymentHistory() {
               // axios
               //     .post(process.env.VUE_APP_API + '/dashboard-integration/payments/history',
               //         {"subscription_id": this.userInfo.plan.subscription_id},
               //         {
               //             headers: {
               //                 'Authorization': localStorage.getItem('token')
               //             }
               //         }
               //     )
            if (this.userInfo && this.userInfo.subscription_info && this.userInfo.subscription_info.active_subscription) {
                let data = {"subscription_id": this.userInfo.plan.subscription_id}
                api_requests.get_payments_history(data)
                    .then(resp => {
                        this.paymentHistoryList = resp.data.data
                        if (this.oldPlans.length > 0) {
                            for (let i = 0; i < this.oldPlans.length; i += 1) {
                                api_requests.get_payments_history({"subscription_id": this.oldPlans[i].id})
                                    .then(resp => {
                                        this.paymentHistoryList.push(resp.data.data.payments.data[0])
                                    })
                                    .catch(err => {
                                        console.log(err)
                                    })
                                // axios
                                //     .post(process.env.VUE_APP_API + '/dashboard-integration/payments/history',
                                //         {"subscription_id": this.oldPlans[i].id},
                                //         {
                                //             headers: {
                                //                 'Authorization': localStorage.getItem('token')
                                //             }
                                //         }
                                //     )

                            }
                        }
                    })
                    .catch(err => {
                        // console.log(err)
                    })
            }

        },
        convert(arg) {
            return this.allPlans.filter(val => val.plan.id === arg.workspace_plan_id)
        }
    },
    created() {
        this.getPaymentHistory()
        this.$store.dispatch('getDetails')
            .then(response => {
                this.info = response.data;
                this.first_name.inp = this.info.first_name
                this.firstName = this.info.first_name
                this.lastName = this.info.last_name
                this.last_name.inp = this.info.last_name
                this.name = this.info.name;
                this.phone = this.info.phone;
                this.mail = this.info.email;
                this.user_plan = this.info.user_plan
                this.billing_plan_list = this.userInfo.all_subscriptions || []
                this.getSubscriptionId()
            })
            .catch(error => {
                this.errored = true;
            })
            .finally(() => {
                setTimeout(() => this.showMainPreloader = false, 500);
            });
    }
}
